import React from 'react'
import { css, cx } from '@emotion/css'

export function LegacyGridContainer({ children }) {
  return (
    <div
      data-testid="legacy-grid-container"
      className={cx(
        'legacy-grid-container',
        css`
          display: flex;
          flex: 1;
        `
      )}
      children={children}
    />
  )
}
